import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, type TabsProps } from '@amzn/awsui-components-react';
import { useImpersonation } from '../../context/ImpersonationContext';
import { useAgent } from '../../context/AgentContext';
import { fetchTasks } from './useTaskData';
import PageHeader from '../../components/PageHeader/PageHeader';
import ScheduledTasksTab from './ScheduledTasksTab';
import ExecutionHistoryTab from './ExecutionHistoryTab';
import './TaskPage.css';

const VALID_TABS = ['scheduled', 'history'] as const;

export default function TaskPage() {
  const { t } = useTranslation('tasks');
  const { effectiveUid } = useImpersonation();
  const { currentAgent } = useAgent();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab');
  const activeTab = VALID_TABS.includes(tabParam as typeof VALID_TABS[number])
    ? tabParam!
    : 'scheduled';

  useEffect(() => {
    if (effectiveUid) fetchTasks(effectiveUid, currentAgent);
  }, [effectiveUid, currentAgent]);

  const handleTabChange = ({ detail }: { detail: TabsProps.ChangeDetail }) => {
    setSearchParams({ tab: detail.activeTabId }, { replace: true });
  };

  return (
    <div className="task-page">
      <PageHeader title={t('page.title')} />
      <div className="task-page__body">
        <Tabs
          activeTabId={activeTab}
          onChange={handleTabChange}
          tabs={[
            {
              id: 'scheduled',
              label: t('page.scheduledTab'),
              content: <ScheduledTasksTab />,
            },
            {
              id: 'history',
              label: t('page.historyTab'),
              content: <ExecutionHistoryTab />,
            },
          ]}
        />
      </div>
    </div>
  );
}
